import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { ListeningPartyCountdown } from '@components/basics/ListeningPartyCountdown';
import { useTimer } from '@hooks/useTimer';

export const HeroCountdown = ({ timestamp }: { timestamp: number }) => {
  const { seconds, minutes, hours, days } = useTimer({
    expiryTimestamp: timestamp,
  });

  return (
    <ListeningPartyCountdown
      seconds={seconds}
      minutes={minutes}
      hours={hours}
      days={days}
      variant="landingPageHeroCleanup"
    />
  );
};

export const CountdownContainer = styled('div', {
  padding: '10px',
  background: 'rgba(255, 255, 255, 0.7)',
  boxShadow: 'inset 2px 2px 24px rgba(255, 255, 255, 0.6)',
  backdropFilter: 'blur(40px) saturate(4)',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

export default HeroCountdown;
